import React, { FC } from "react";
import { Navigate } from "react-router-dom";

import { PATHS } from "../../config/paths";
import { useSiteData } from "../../contexts/SiteDataContext";
import LoadingSpinner from "../LoadingSpinner";
import type { ProtectedRoutePropsType } from "./ProtectedRouteTypes";

const ProtectedRoute: FC<ProtectedRoutePropsType> = ({ children }) => {
  const { authState } = useSiteData();

  // Wait for authentication state to be loaded
  if (authState.isLoading) {
    return <LoadingSpinner />;
  }

  // If user is not authenticated, redirect to main page
  if (!authState.isAuthenticated) {
    return <Navigate to={PATHS.MAIN} replace />;
  }

  // If user is authenticated, render the protected component
  return <>{children}</>;
};

export default ProtectedRoute;
